import { render, staticRenderFns } from "./VeButtonBlock.vue?vue&type=template&id=a0a21b68&scoped=true"
import script from "./VeButtonBlock.vue?vue&type=script&lang=js"
export * from "./VeButtonBlock.vue?vue&type=script&lang=js"
import style0 from "./VeButtonBlock.vue?vue&type=style&index=0&id=a0a21b68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a21b68",
  null
  
)

export default component.exports